// extracted by mini-css-extract-plugin
export default {"advertDetailContactItem":"c-m_fi","advertDetailContactItem__link":"c-m_fj","advertDetailContactItem__stub":"c-m_fk"};